import { render, staticRenderFns } from "./label-editor.vue?vue&type=template&id=5d9d81e5&scoped=true&"
import script from "./label-editor.vue?vue&type=script&lang=js&"
export * from "./label-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9d81e5",
  null
  
)

export default component.exports